module.exports = __webpack_public_path__ + "media/components/country-flag/static/ne-587078992dffd207ea1b50c21d681a92.svg";